import { render, staticRenderFns } from "./TransactionPrivateLiveChat.vue?vue&type=template&id=19ba45c4&"
import script from "./TransactionPrivateLiveChat.vue?vue&type=script&lang=ts&"
export * from "./TransactionPrivateLiveChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports